if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.photoCache = new Map();
        this.photoRequest = 0;
        const navigation = this.querySelector('.ember-photo-viewer__nav');
        // Dawn closes media modals on mouse pointer-up. Navigation must stay open.
        navigation?.addEventListener('pointerup', (event) => event.stopPropagation());
        navigation?.addEventListener('click', (event) => {
          event.stopPropagation();
          const button = event.target.closest('[data-photo-step]');
          if (button && !button.disabled) this.stepPhoto(Number(button.dataset.photoStep));
        });
        this.addEventListener('keydown', (event) => {
          if (!this.hasAttribute('data-photo-viewer') || !this.hasAttribute('open')) return;
          if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
            event.preventDefault();
            this.stepPhoto(event.key === 'ArrowLeft' ? -1 : 1);
          }
        });
        this.addEventListener('click', (event) => {
          if (!this.hasAttribute('open') || event.target.closest('.ember-photo-viewer__nav')) return;
          if (this.hasAttribute('data-photo-viewer') || (this.isMobileMug3() && this.querySelector('img.active'))) {
            this.hide();
          }
        });
      }

      isMobileMug3() {
        return this.classList.contains('product-media-modal--mug3') && window.matchMedia('(max-width: 749px)').matches;
      }

      preparePhotos(opener) {
        if (!this.classList.contains('product-media-modal--mug3')) return false;
        const gallery = opener.closest('media-gallery');
        if (!gallery || !opener.closest('.product__modal-opener--image')) return false;
        this.photos = Array.from(gallery.querySelectorAll('.product__modal-opener--image')).map((item) => {
          const image = item.querySelector('.product__media img');
          const button = item.querySelector('button[data-media-id]');
          if (!image || !button) return null;
          const fullUrl = new URL(item.dataset.fullImage || image.src, document.baseURI).href;
          const previewUrl = new URL(fullUrl);
          previewUrl.searchParams.set('width', '493');
          return {
            id: button.dataset.mediaId,
            alt: image.alt,
            previewUrl: image.currentSrc || previewUrl.href,
            fullUrl,
          };
        }).filter(Boolean);
        this.photoIndex = this.photos.findIndex((photo) => photo.id === opener.dataset.mediaId);
        return this.photoIndex >= 0;
      }

      loadPhoto(photo) {
        const cached = this.photoCache.get(photo.fullUrl);
        if (cached) return cached;
        const image = new Image();
        image.decoding = 'async';
        const entry = { image, ready: false };
        entry.promise = new Promise((resolve) => {
          image.onload = async () => {
            try { await image.decode(); } catch (_) { /* A loaded image is still usable. */ }
            entry.ready = true;
            resolve(image);
          };
          image.onerror = () => resolve(null);
        });
        this.photoCache.set(photo.fullUrl, entry);
        image.src = photo.fullUrl;
        return entry;
      }

      showPhoto(index) {
        const count = this.photos.length;
        this.photoIndex = (index + count) % count;
        const photo = this.photos[this.photoIndex];
        const viewer = this.querySelector('.ember-photo-viewer');
        const preview = viewer.querySelector('.ember-photo-viewer__preview');
        const full = viewer.querySelector('.ember-photo-viewer__full');
        const request = ++this.photoRequest;
        const cached = this.photoCache.get(photo.fullUrl);
        full.hidden = true;
        preview.alt = photo.alt;
        // Reuse the already-decoded carousel image for the first visible frame.
        preview.src = cached?.ready ? cached.image.src : photo.previewUrl;
        viewer.dataset.photoId = photo.id;
        viewer.querySelector('.ember-photo-viewer__count').textContent = `${this.photoIndex + 1} / ${count}`;
        viewer.querySelectorAll('[data-photo-step]').forEach((button) => { button.disabled = count < 2; });
        this.loadPhoto(photo).promise.then((image) => {
          if (!image || request !== this.photoRequest || !this.hasAttribute('open')) return;
          full.src = image.src;
          full.hidden = false;
        });
        // Warm only the neighboring photos, not the whole product media library.
        if (count > 1) {
          this.loadPhoto(this.photos[(this.photoIndex + 1) % count]);
          this.loadPhoto(this.photos[(this.photoIndex + count - 1) % count]);
        }
      }

      stepPhoto(direction) {
        if (this.photos?.length > 1) this.showPhoto(this.photoIndex + direction);
      }

      hide() {
        ++this.photoRequest;
        super.hide();
        if (this.hasAttribute('popover')) {
          this.hidePopover();
          this.removeAttribute('popover');
        }
        this.removeAttribute('data-photo-viewer');
        const viewer = this.querySelector('.ember-photo-viewer');
        if (viewer) viewer.hidden = true;
      }

      show(opener) {
        const photoViewer = this.preparePhotos(opener);
        this.toggleAttribute('data-photo-viewer', photoViewer);
        const viewer = this.querySelector('.ember-photo-viewer');
        if (viewer) viewer.hidden = !photoViewer;
        if ((photoViewer || this.isMobileMug3()) && typeof this.showPopover === 'function') {
          this.setAttribute('popover', 'manual');
          this.showPopover();
        }
        super.show(opener);
        if (photoViewer) this.showPhoto(this.photoIndex);
        else this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => { element.classList.remove('active'); });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        if (!activeMedia) return;
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        const container = this.querySelector('[role="document"]');
        if (this.isMobileMug3()) {
          container.scrollTop = 0;
          container.scrollLeft = 0;
        } else {
          activeMedia.scrollIntoView();
          container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;
        }
        if (activeMedia.nodeName === 'DEFERRED-MEDIA' && activeMediaContent?.querySelector('.js-youtube')) {
          activeMedia.loadContent();
        }
      }
    }
  );
}
